import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';

import Button from '@Hotels-at-Home/hah-fe-core/dist/components/Button';
import Link from '@Hotels-at-Home/hah-fe-core/dist/components/Link';

const BathSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$bathSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tCommon } = useTranslation('', { keyPrefix: '$common' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$bath' });

  return (
    <section className="base-section bath-section">
      <div className="branding-hero">
        <div className="title">
          <a href={tLink('bathMain')}>
            <h2>{t('copy')}</h2>
            <Button
              className="base-btn mobile-viewport"
              noTabbing
              ariaLabel={`${tButton('shopNow')}: ${t('towels')}`}
            >
              <span>{tButton('shopNow')}</span>
            </Button>
          </a>
        </div>
        <a
          className="bath-product-wrap hover-btn-animation"
          href={tLink('towels')}
          id="HP_bath_towels"
        >
          <picture>
            <source
              srcSet="/images/homePage/bathSection/sheu-towels-set-mob.webp"
              media="(max-width: 960px)"
            />
            <img
              src="/images/homePage/bathSection/sheu-towels-set.webp"
              alt={t('towels')}
              width={755}
              height={787}
              loading="lazy"
              decoding="async"
              fetchPriority="low"
            />
          </picture>
          <Button
            variant="txt"
            className="base-btn bg-transparent"
            noTabbing
            ariaLabel={`${tButton('shopNow')}: ${t('towels')}`}
          >
            <h3>{t('towels')}</h3>
          </Button>
        </a>
      </div>
      <div className="branding-hero">
        <a
          className="bath-product-wrap hover-btn-animation"
          href={tLink('bathSets')}
          id="HP_bath_bath-sets"
        >
          <picture>
            <source
              srcSet="/images/homePage/bathSection/sheu-body-set-mob.webp"
              media="(max-width: 960px)"
            />
            <img
              src="/images/homePage/bathSection/sheu-body-set.webp"
              alt={t('bathSets')}
              width={755}
              height={787}
              loading="lazy"
              decoding="async"
              fetchPriority="low"
            />
          </picture>
          <Button
            variant="txt"
            className="base-btn bg-transparent"
            noTabbing
            ariaLabel={`${tButton('shopNow')}: ${t('bathSets')}`}
          >
            <h3>{t('bathSets')}</h3>
          </Button>
        </a>
      </div>
      <div className="branding-hero">
        <a
          className="bath-product-wrap hover-btn-animation"
          href={tLink('robes')}
          id="HP_bath_robes"
        >
          <picture>
            <source
              srcSet="/images/homePage/bathSection/sheu-robes-mob.webp"
              media="(max-width: 960px)"
            />
            <img
              src="/images/homePage/bathSection/sheu-robes.webp"
              alt={t('robes')}
              width={755}
              height={787}
              loading="lazy"
              decoding="async"
              fetchPriority="low"
            />
          </picture>
          <Button
            variant="txt"
            className="base-btn bg-transparent"
            noTabbing
            ariaLabel={`${tButton('shopNow')}: ${t('robes')}`}
          >
            <h3>{t('robes')}</h3>
          </Button>
        </a>
      </div>
    </section>
  );
};

export default BathSection;
